import { Injectable, Output, EventEmitter } from '@angular/core';
import 'rxjs/add/operator/map';

/*
  Generated class for the AuthStore provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular 2 DI.
*/
@Injectable()
export class BadgeStore {

  @Output() onChangeBadge = new EventEmitter<Object>();

  private _data = {};
  private setBadge(key, count){
    if(count == 0) count = null;
    this._data[key] = count;
    this.onChangeBadge.emit({key:key, count:count});
  }
  setBadgePhotoRequest(count){
    this.setBadge("picture", count);
  }
  setBadgeReserveRequest(count) {
    this.setBadge("reserve", count);
  }
  getBadge(key){
    return this._data[key];
  }
  getBadges(){
    return this._data;
  }
}


// WEBPACK FOOTER //
// ./src/stores/badge-store.ts